import { styled } from '@mui/material/styles';
import Typography from '../../library/Typography';
import { MuiBox } from '../../../../../modules/material';

export const Wrapper = styled(MuiBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const IconWrapper = styled('div')`
  margin-bottom: 16px;
  max-width: 80px;
  max-height: 80px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Title = styled(Typography)`
  margin-bottom: 4px;
`;

export const Description = styled(Typography)`
  margin-bottom: 16px;
`;
